import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import HeaderCategoryService from './services/HeaderCategoryService'
import HeaderDomesticSearchService from './services/HeaderDomesticSearchService'
import HeaderInternationalService from './services/HeaderInternationalService'

export const postHeaderDomesticSearch = createAsyncThunk(
  'headerSearch/POST_HEADER_DOMESTIC_SEARCH',
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await HeaderDomesticSearchService.postHeaderDomesticSearch(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postHeaderSearchHistories = createAsyncThunk(
  'headerSearch/POST_HEADER_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await HeaderDomesticSearchService.postHeaderSearchHistories(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHeaderSearchHistories = createAsyncThunk(
  'headerSearch/GET_HEADER_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await HeaderDomesticSearchService.getHeaderSearchHistories(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteHeaderSearchHistories = createAsyncThunk(
  'headerSearch/DELETE_HEADER_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await HeaderDomesticSearchService.deleteHeaderSearchHistories(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHeaderActiveStatus = createAsyncThunk(
  'headerSearch/GET_HEADER_CATEGORY_ACTIVE_STATUS',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HeaderCategoryService.getHeaderActiveStatus(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCountries = createAsyncThunk(
  'headerSearch/GET_COUNTRY',
  async (_, { rejectWithValue }) => {
    try {
      const response = await HeaderInternationalService.getCountries()
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getInternationalSearchHistory = createAsyncThunk(
  'headerSearch/GET_INTERNATIONAL_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HeaderInternationalService.getSearchHistory(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postInternationalSearchHistory = createAsyncThunk(
  'headerSearch/POST_INTERNATIONAL_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HeaderInternationalService.postSearchHistory(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteInternationalSearchHistory = createAsyncThunk(
  'headerSearch/DELETE_INTERNATIONAL_SEARCH_HISTORIES',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HeaderInternationalService.deleteSearchHistory(
        data,
      )
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getInternationalCompany = createAsyncThunk(
  'headerSearch/GET_INTERNATIONAL_COMPANY',
  async (data, { rejectWithValue }) => {
    try {
      const response = await HeaderInternationalService.getCompany(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
